import { Trans, useTranslation } from 'react-i18next';
import {
  FontWeight,
  Heading,
  LiliTooltip,
  LiliToolTipColor,
  TooltipPosition,
} from '@lili/lili-frontend-common';

export const AgreementToolTip = () => {
  const { t } = useTranslation('enJSON');

  return (
    <div className='flex items-center gap-[4px]'>
      <h1 className='text-text-main-tertiary text-[14px] leading-[14px]'>
        <Trans
          i18nKey='pages.nonUsIdentity.agreementText'
          ns='enJSON'
          components={{
            underline: (
              <span
                className='text-text-main-tertiary text-[14px] leading-[14px] underline'
                data-tooltip-id='tool-tip-personal-data-consent'
              />
            ),
          }}
        />
      </h1>

      <LiliTooltip
        title=''
        description=''
        className='max-w-[372px] rounded-xl'
        customContent={
          <div className='flex flex-col px-[14px] py-[14px] w-full gap-[12px]'>
            <Heading.H10 fontWeight={FontWeight.MEDIUM} className='text-surface-primary-bw-08'>
              {t('pages.nonUsIdentity.agreementToolTipHeader')}
            </Heading.H10>
            <Heading.H10 fontWeight={FontWeight.REGULAR} className='text-surface-primary-bw-07'>
              {t('pages.nonUsIdentity.agreementToolTipBody')}
            </Heading.H10>
          </div>
        }
        color={LiliToolTipColor.White}
        position={TooltipPosition.RIGHT}
        targetId='tool-tip-personal-data-consent'
      />
    </div>
  );
};
